import { render, staticRenderFns } from "./StoreHome.vue?vue&type=template&id=79a32674&scoped=true&"
import script from "./StoreHome.vue?vue&type=script&lang=js&"
export * from "./StoreHome.vue?vue&type=script&lang=js&"
import style0 from "./StoreHome.vue?vue&type=style&index=0&id=79a32674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a32674",
  null
  
)

export default component.exports